import React from "react";
import moment from "moment";

import { DATETIME_FORMAT_FRONTEND, DATE_FORMAT_FRONTEND } from "../../constants";
import TableBase from "./Base";
import { getTranslation } from "../../utils/helper";

const DriversTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Drivers", "Driver Name"),
      dataIndex: "name",
      width: 200,
      ellipsis: true,
      fixed: true,
      render(name, record) {
        return <span style={{ color: `#${record.color}` }}>{name}</span>;
      },
    },
    {
      title: getTranslation(setting, "Drivers", "Date Added"),
      dataIndex: "createdAt",
      width: 200,
      ellipsis: true,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Drivers", "Email"),
      dataIndex: "email",
      width: 250,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Drivers", "Phone Number"),
      dataIndex: "phone",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Drivers", "Shift Time"),
      dataIndex: "shiftTime",
      width: 150,
      ellipsis: true,
      render(_shift, record) {
        return (
          <span>
            {record.shiftStart} - {record.shiftEnd}
          </span>
        );
      },
    },
    {
      title: getTranslation(setting, "Drivers", "Speed"),
      dataIndex: "speed",
      width: 100,
      ellipsis: true,
      render(speed) {
        const speeds = {
          X2SLOWER: getTranslation(setting, "Drivers", "Slow"),
          SLOWER: getTranslation(setting, "Drivers", "Slow"),
          SLOW: getTranslation(setting, "Drivers", "Slow"),
          NORMAL: getTranslation(setting, "Drivers", "Normal"),
          FAST: getTranslation(setting, "Drivers", "Fast"),
          FASTER: getTranslation(setting, "Drivers", "Fast"),
          X2FASTER: getTranslation(setting, "Drivers", "Fast"),
        };
        return <span>{speeds[speed]}</span>;
      },
    },
    {
      title: getTranslation(setting, "Drivers", "Capacity"),
      dataIndex: "capacity",
      width: 100,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Drivers", "Start Location"),
      dataIndex: "startAddress",
      width: 350,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Drivers", "End Location"),
      dataIndex: "endAddress",
      width: 350,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Drivers", "Updated At"),
      dataIndex: "updatedAt",
      width: 250,
      render(value) {
        return value ? moment(value).format(DATETIME_FORMAT_FRONTEND) : "-";
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default DriversTable;
